<template>
  <div class="report-result">
    <NavBar
      class="nav"
      :title="$route.query.title || $t('result.工单')"
      :goBack="onClickLeft"
    />
    <div class="content">
      <div class="infos">
        <img
          src="@/assets/img/create_success.png"
          style="width: 135px; object-fit: contain;"
          alt=""
        />
        <span class="tip">{{ $t("result.工单创建成功") }}</span>
      </div>
      <div class="btns">
        <van-button
          type="primary"
          class="back"
          style="margin-right: 30px"
          @click="goRoute(1)"
          >{{ $t("result.返回首页") }}</van-button
        >
        <van-button class="detail" type="primary" @click="goRoute(2)">{{
          $t("result.查看工单")
        }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReportResult",
  data() {
    return {};
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    goRoute(index) {
      if (index === 1) {
        this.$router.push({
          name: "UserCenter",
        });
      } else {
        const id = this.$route.query.id;
        this.$router.push({
          name: "ReportRecord",
          query: {
            type: 0,
            id,
          },
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.report-result {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #fff;
  .nav {
    flex: 0 0 auto;
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 102px;
    box-sizing: border-box;
    .infos {
      display: flex;
      flex-direction: column;
      align-items: center;
      line-height: 28px;

      .tip {
        margin-top: 26px;
        color: #666;
        font-size: 14px;
      }
    }
    .btns {
      display: flex;
      align-items: center;
      margin-top: 60px;
      button {
        width: 144px;
        height: 40px;
        font-size: 15px;
        border-radius: 4px;
      }
      .back {
        background-color: #fff;
        border: 1px solid @gold;
        color: @gold;
      }
    }
  }
}
</style>
